import { Box, BoxProps, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export type TipProps = {
  title: string;
  description: string;
} & BoxProps;

export const Tip: React.VFC<TipProps> = ({ title, description, className, ...props }) => {
  const { classes, cx } = useTipStyles();

  return (
    <Box className={cx(classes.root, className)} {...props}>
      <Typography variant="body2" className={classes.title} color="textPrimary">{title}</Typography>
      <Typography variant="body2" color="textPrimary">{description}</Typography>
    </Box>
  );
};

const useTipStyles = makeStyles({ name: 'Tip' })(theme => ({
  root: {
    background: theme.palette.info.background,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
  },
  title: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(1),
  }
}));
